<template>
  <q-card flat>
    <q-card-section>
      Adjust start month of financial period
      <q-separator class="q-mt-sm q-mb-sm" />
    </q-card-section>

    <q-card-section>
      <div class="row q-col-gutter-lg">
        <EnhancedQSelect
          v-model="selectedMonth"
          :options="months"
          class="col-xs-6"
          label="Start month of financial period"
        />
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import { months } from './months'
// Components
import EnhancedQSelect from '@components/general/EnhancedQSelect'

export default {
  components: {
    EnhancedQSelect
  },

  data: () => ({
    selectedMonth: null
  }),

  computed: {
    months() {
      return months
    }
  },

  watch: {
    selectedMonth: 'notifyParentForTheSelectedMonth'
  },

  created() {
    this.selectedMonth = this.settings.financial_period_start_month
  },

  methods: {
    notifyParentForTheSelectedMonth() {
      this.$emit('selected-month', this.selectedMonth)
    },

    getData() {
      return this.selectedMonth
    }
  }
}
</script>
